// assets/financiamiento-producto.js
//
// Calculadora de financiamiento — iShop Colombia
//
// v7 — Referencias sin financiación en ningún banco (MacBook Neo desde el
// 1 nov 2026). Liquid manda sinFinanciacion (match por tipo, sin mirar la
// fecha) y sinFinanciacionDesde; aquí se decide con la hora de Colombia y la
// sección entera se oculta desde ese día, sin excepción de banco. Fecha vacía
// o inválida = oculta ya (fail-closed). Corre al final de applyCampaignGates
// para ganarle a syncExclusionGlobal, que podría volver a mostrarla.
//
// v6 — Bancolombia y Banco de Bogotá también cubren la exclusión global en
// las referencias de su lista de incluidos (hoy iPhone 13/14/15, por los T&C
// de oct–dic 2026). Liquid resuelve qué tarjetas entran al DOM; aquí el flag
// pasa de soloNubank a exclusionGlobal y la sección se oculta solo cuando
// no queda NINGUNA tarjeta visible, no cuando se oculta la de Nubank.
//
// v5 — Nubank entra como OCTAVO banco, con namespace propio (nubank*) y sin
// tocar las reglas de los siete anteriores.
//
// Reglas de Nubank (campaña 5 oct 2026 – 31 dic 2026), todas desde settings:
//   - Tarjeta visible solo dentro de su ventana de campaña, en hora de
//     Colombia y fail-closed ante fechas inválidas, igual que Codensa.
//   - Mínimo 600.000. PVP < 4.600.000 -> 9,12; PVP >= 4.600.000 -> 9,12,18,24.
//   - Cubre la exclusión global (iPhone 15): en esos productos Liquid solo
//     renderiza las tarjetas que la cubren (desde v6, Bancolombia y Bogotá
//     también) y, si todas se ocultan, se oculta la calculadora entera.
//
// v4 — Crédito Fácil Codensa entra como SÉPTIMO banco, con namespace propio
// (codensa*) y sin tocar las reglas de los seis anteriores. La emite Davibank,
// pero no es DAVIbank ni Davivienda.
//
// Reglas de Codensa (campaña 25 sep 2026 – 31 oct 2026), todas desde settings:
//   - Tarjeta visible solo dentro de su ventana de campaña, en hora de
//     Colombia y fail-closed ante fechas inválidas, igual que DAVIbank.
//   - Mínimo 800.000. PVP < 4.600.000 -> 6,12; PVP >= 4.600.000 -> 6,12,18.
//   - Solo marca Apple y sin iPhone 15: ambas se resuelven en Liquid (la
//     marca no cambia al cambiar de variante), así que si no aplican la
//     tarjeta ni siquiera llega al DOM.
//
// v3 — DAVIbank es un banco NUEVO e INDEPENDIENTE (no es Davivienda).
// Este archivo agrega DAVIbank como sexto banco sin modificar las reglas de
// los cinco existentes:
//   - Bancolombia, Davivienda, Bogotá, BBVA y AV Villas: misma lógica de
//     producción (umbrales, cuotas, visibilidad, promo legacy).
//   - Davivienda conserva su mínimo (600.000 vía settings/default), su
//     umbral y su Plan 0es3. Nada de eso cambia aquí.
//   - La promo legacy (promo_*) sigue aplicando a los bancos que diga su
//     setting (default: bancolombia,davivienda), con una sola fase, igual
//     que siempre.
//
// Reglas de DAVIbank (campaña 4 ago 2026 – 30 sep 2026):
//   - Tarjeta visible solo dentro de la ventana de campaña (evaluada en JS
//     por el cache de CDN, en hora de Colombia; fail-closed ante fechas
//     inválidas).
//   - Mínimo 800.000. PVP < 4.600.000 -> 6,12; PVP >= 4.600.000 -> 6,12,18.
//   - SOLO los skus exactos iPhone 17 / 17e / 17 Pro / 17 Pro Max /
//     MacBook Neo (match exacto resuelto en Liquid):
//       4–31 ago: 6,12,18,24 · 1–30 sep: 6,12,18.
//   - iPhone 13/14/15 excluidos del beneficio (su tarjeta no se renderiza;
//     resuelto en Liquid, no afecta a los demás bancos).
//
// Bugfix conservado sobre la promo legacy: las fechas se validan de forma
// estricta y se comparan numéricamente. La comparación lexicográfica
// anterior aceptaba valores como "2026-08-031" y cerraba la ventana en
// silencio; el resultado neto con un valor así es el mismo (promo apagada),
// pero ahora queda un error visible en consola.

// ========== DROPDOWN FUNCTIONALITY ==========
function toggleFinanciamiento() {
  document.getElementById('financiamiento-dropdown').classList.toggle('open');
}

function initializeDropdownState() {
  const dropdown = document.getElementById('financiamiento-dropdown');
  if (!dropdown) return;
  const isMobile = window.innerWidth <= 768;
  dropdown.classList.toggle('open', !isMobile);
}

function handleResize() {
  const dropdown = document.getElementById('financiamiento-dropdown');
  if (!dropdown) return;
  const isMobile = window.innerWidth <= 768;
  const wasMobile = dropdown.hasAttribute('data-was-mobile')
    ? dropdown.getAttribute('data-was-mobile') === 'true'
    : null;
  if (wasMobile !== null && wasMobile !== isMobile) initializeDropdownState();
  dropdown.setAttribute('data-was-mobile', isMobile.toString());
}

// ========== PLAN 0 ES 3 TOGGLE ==========
function togglePlan0es3(event) {
  event.preventDefault();
  const el = document.getElementById('plan-0es3-benefits');
  if (el) el.style.display = (el.style.display === 'none' || !el.style.display) ? 'block' : 'none';
}

// ========== BANK SELECTION ==========
function selectBank(bankKey) {
  if (!window._financiamientoState) return;
  const state = window._financiamientoState;

  // No hacer nada si la tarjeta está oculta (por precio o, en DAVIbank,
  // por ventana de campaña)
  const targetCard = document.querySelector(`.bank-card[data-bank="${bankKey}"]`);
  if (!targetCard || targetCard.style.display === 'none') return;

  state.selectedBank = bankKey;

  document.querySelectorAll('.bank-card[data-bank]').forEach(card => {
    card.classList.toggle('bank-card--active', card.dataset.bank === bankKey);
  });

  const nameEl = document.getElementById('banco-activo-nombre');
  if (nameEl) {
    nameEl.textContent = (state.bankNames && state.bankNames[bankKey]) || bankKey;
  }

  populateSelector(state.banksConfig[bankKey] || state.banksConfig.bancolombia);
}

// ========== CALCULADORA DE FINANCIAMIENTO ==========
document.addEventListener('DOMContentLoaded', () => {
  initializeDropdownState();
  window.removeEventListener('resize', handleResize);
  window.addEventListener('resize', handleResize);

  const productInfoSection = document.querySelector('product-info.product__info-container');
  if (!productInfoSection) return;

  const selector      = document.getElementById('selector-cuotas');
  const resultElement = document.getElementById('resultado-cuota');
  const financingData = document.getElementById('financiamiento-data');
  if (!selector || !resultElement || !financingData) return;

  // ---- Parse data from Liquid ----
  function parseCuotas(str) {
    return (str || '')
      .split(',')
      .map(c => parseInt(c.trim()))
      .filter(c => !isNaN(c))
      .sort((a, b) => a - b);
  }

  let data                   = {};
  let cuotasGenerales        = [];
  let cuotasDaviviendaAlto   = [];
  let cuotasDaviviendaBajo   = [];
  let cuotasBogotaIphone     = [];
  let cuotasBogotaMac        = [];
  let cuotasBbvaIphone       = [];
  let cuotasBbvaMac          = [];
  let cuotasBbvaOtros        = [];   // BBVA: todo lo que no es iPhone ni Mac
  let cuotasAvVillasIphone   = [];
  let cuotasAvVillasMac      = [];
  let daviviendaUmbral       = 4300000;  // SIN CAMBIOS (Davivienda ≠ DAVIbank)
  let daviviendaPrecioMinimo = 600000;   // SIN CAMBIOS — mínimo exclusivo de Davivienda
  let precioMinimoOtros      = 800000;   // Mínimo para todos los demás bancos

  // Promo legacy (bancos existentes, una sola fase — SIN CAMBIOS de reglas)
  let promoCuotas            = [];
  let promoBancos            = [];

  // DAVIbank (banco nuevo)
  let cuotasDavibankAlto     = [];
  let cuotasDavibankBajo     = [];
  let davibankUmbral         = 4600000;
  let davibankPrecioMinimo   = 800000;
  let davibankPromoCuotas    = [];   // fase 1: 6,12,18,24
  let davibankCuotasFase2    = [];   // fase 2: 6,12,18

  // Crédito Fácil Codensa (banco nuevo, sin fases)
  let cuotasCodensaAlto      = [];
  let cuotasCodensaBajo      = [];
  let codensaUmbral          = 4600000;
  let codensaPrecioMinimo    = 800000;

  // Nubank (banco nuevo, sin fases)
  let cuotasNubankAlto       = [];
  let cuotasNubankBajo       = [];
  let nubankUmbral           = 4600000;
  let nubankPrecioMinimo     = 600000;

  try {
    data = JSON.parse(financingData.textContent);
    cuotasGenerales        = parseCuotas(data.cuotasDisponibles);
    cuotasDaviviendaAlto   = parseCuotas(data.cuotasDaviviendaAlto);
    cuotasDaviviendaBajo   = parseCuotas(data.cuotasDaviviendaBajo);
    cuotasBogotaIphone     = parseCuotas(data.bogotaCuotasIphone);
    cuotasBogotaMac        = parseCuotas(data.bogotaCuotasMac);
    cuotasBbvaIphone       = parseCuotas(data.bbvaCuotasIphone);
    cuotasBbvaMac          = parseCuotas(data.bbvaCuotasMac);
    cuotasBbvaOtros        = parseCuotas(data.bbvaCuotasOtros);
    cuotasAvVillasIphone   = parseCuotas(data.avVillasCuotasIphone);
    cuotasAvVillasMac      = parseCuotas(data.avVillasCuotasMac);
    daviviendaUmbral       = data.daviviendaUmbral       || daviviendaUmbral;
    daviviendaPrecioMinimo = data.daviviendaPrecioMinimo || daviviendaPrecioMinimo;
    precioMinimoOtros      = data.precioMinimoOtros      || precioMinimoOtros;

    promoCuotas = parseCuotas(data.promoCuotas);
    promoBancos = (data.promoBancos || '')
      .split(',')
      .map(b => b.trim().toLowerCase())
      .filter(Boolean);

    cuotasDavibankAlto   = parseCuotas(data.davibankCuotasAlto);
    cuotasDavibankBajo   = parseCuotas(data.davibankCuotasBajo);
    davibankUmbral       = data.davibankUmbral       || davibankUmbral;
    davibankPrecioMinimo = data.davibankPrecioMinimo || davibankPrecioMinimo;
    davibankPromoCuotas  = parseCuotas(data.davibankPromoCuotas);
    davibankCuotasFase2  = parseCuotas(data.davibankCuotasFase2);

    cuotasCodensaAlto   = parseCuotas(data.codensaCuotasAlto);
    cuotasCodensaBajo   = parseCuotas(data.codensaCuotasBajo);
    codensaUmbral       = data.codensaUmbral       || codensaUmbral;
    codensaPrecioMinimo = data.codensaPrecioMinimo || codensaPrecioMinimo;

    cuotasNubankAlto    = parseCuotas(data.nubankCuotasAlto);
    cuotasNubankBajo    = parseCuotas(data.nubankCuotasBajo);
    nubankUmbral        = data.nubankUmbral       || nubankUmbral;
    nubankPrecioMinimo  = data.nubankPrecioMinimo || nubankPrecioMinimo;
  } catch (e) {
    console.error('Error parsing financing data:', e);
    return;
  }

  if (cuotasGenerales.length === 0) {
    const section = document.querySelector('.financiamiento-section');
    if (section) section.style.display = 'none';
    return;
  }

  const productTypeLower = (data.productType || '').toLowerCase();

  // ---- Nombres visibles de banco ----
  const bankNames = {
    bancolombia: 'Bancolombia',
    davivienda:  'Davivienda',
    bogota:      'Banco de Bogotá',
    bbva:        'BBVA',
    av_villas:   'AV Villas',
    davibank:    'DAVIbank',
    codensa:     'Crédito Fácil Codensa',
    nubank:      'Nubank',
  };

  // ---- Fechas: parseo estricto y comparación numérica ----
  // Se comparan enteros YYYYMMDD, no strings (la comparación lexicográfica
  // aceptaba basura como "2026-08-031" en silencio).
  function isoToNum(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((value || '').trim());
    if (!m) return null;
    const y  = Number(m[1]);
    const mo = Number(m[2]);
    const d  = Number(m[3]);
    if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
    // Verificación real de calendario (rechaza 2026-02-30, 2026-04-31, etc.)
    const probe = new Date(Date.UTC(y, mo - 1, d));
    if (probe.getUTCFullYear() !== y || probe.getUTCMonth() !== mo - 1 || probe.getUTCDate() !== d) {
      return null;
    }
    return y * 10000 + mo * 100 + d;
  }

  // Las ventanas se evalúan en hora de Colombia (UTC-5, sin DST), no en la
  // hora del dispositivo.
  const TZ_OFFSET_MINUTES = -300; // America/Bogota
  function todayNum() {
    const now = new Date();
    const bog = new Date(now.getTime() + (now.getTimezoneOffset() + TZ_OFFSET_MINUTES) * 60000);
    return bog.getFullYear() * 10000 + (bog.getMonth() + 1) * 100 + bog.getDate();
  }

  // ---- Promo LEGACY (bancos existentes) — misma semántica de siempre ----
  const rawPromoStart = (data.promoStart || '').trim();
  const rawPromoEnd   = (data.promoEnd   || '').trim();
  const promoStartNum = isoToNum(rawPromoStart);
  const promoEndNum   = isoToNum(rawPromoEnd);

  const promoFechasInvalidas = [];
  if (rawPromoStart && promoStartNum === null) promoFechasInvalidas.push(`promo_start_date="${rawPromoStart}"`);
  if (rawPromoEnd   && promoEndNum   === null) promoFechasInvalidas.push(`promo_end_date="${rawPromoEnd}"`);
  const promoDatesValid = promoFechasInvalidas.length === 0;
  if (data.promoEnabled && !promoDatesValid) {
    console.error(
      '[financiamiento] Promo legacy DESACTIVADA: fecha(s) inválida(s) en Theme Settings. ' +
      'Formato requerido YYYY-MM-DD. Revisar: ' + promoFechasInvalidas.join(', ')
    );
  }

  function promoWindowOpen() {
    const t = todayNum();
    if (promoStartNum !== null && t < promoStartNum) return false;
    if (promoEndNum   !== null && t > promoEndNum)   return false;
    return true;
  }

  function promoApplies(priceInCOP) {
    // Producto de la exclusión global: el Liquid nunca evalúa la promo para
    // él, así que aquí tampoco, aunque Mercadeo meta en promo_bancos a un
    // banco que sí lo cubre (Bancolombia, Bogotá, Nubank).
    if (data.exclusionGlobal) return false;
    if (!data.promoEnabled)   return false;
    if (!data.promoTypeMatch) return false;
    if (!promoDatesValid)     return false;
    if (!promoCuotas.length)  return false;
    if (!promoBancos.length)  return false;
    if (!promoWindowOpen())   return false;
    const min = Number(data.promoPrecioMinimo) || 0;
    if (min > 0 && (!priceInCOP || priceInCOP < min)) return false;
    return true;
  }

  // Sobrescribe in-place las cuotas de los bancos incluidos en la promo legacy.
  function applyPromo(config, priceInCOP) {
    if (!promoApplies(priceInCOP)) return config;
    promoBancos.forEach(bank => {
      if (bank in config) config[bank] = promoCuotas;
    });
    return config;
  }

  // ---- DAVIbank: ventana de campaña y cuotas ----
  const rawDbInicio  = (data.davibankCampanaInicio || '').trim();
  const rawDbFin     = (data.davibankCampanaFin    || '').trim();
  const rawDbFase1   = (data.davibankFase1Fin      || '').trim();
  const dbInicioNum  = isoToNum(rawDbInicio);
  const dbFinNum     = isoToNum(rawDbFin);
  const dbFase1Num   = isoToNum(rawDbFase1);

  const dbErrores = [];
  if (rawDbInicio && dbInicioNum === null) dbErrores.push(`davibank_campana_inicio="${rawDbInicio}"`);
  if (rawDbFin    && dbFinNum    === null) dbErrores.push(`davibank_campana_fin="${rawDbFin}"`);
  if (rawDbFase1  && dbFase1Num  === null) dbErrores.push(`davibank_promo_fase1_fin="${rawDbFase1}"`);
  const dbDatesValid = dbErrores.length === 0;
  if (!dbDatesValid) {
    console.error(
      '[financiamiento] DAVIbank OCULTO (fail-closed): fecha(s) de campaña ' +
      'inválida(s) en Theme Settings. Formato requerido YYYY-MM-DD. Revisar: ' +
      dbErrores.join(', ')
    );
  }

  // Fecha inválida = tarjeta oculta (fail-closed): mejor no mostrar el banco
  // que mostrarlo con una vigencia que nadie puede garantizar.
  // Extremo vacío = sin límite en ese extremo.
  function davibankWindowOpen() {
    if (!dbDatesValid) return false;
    const t = todayNum();
    if (dbInicioNum !== null && t < dbInicioNum) return false;
    if (dbFinNum    !== null && t > dbFinNum)    return false;
    return true;
  }

  // Cuotas de DAVIbank para el precio/día actual.
  // - Sku de la lista exacta (davibankTypeMatch, resuelto en Liquid):
  //     hasta fase1_fin inclusive -> 6,12,18,24 · después -> 6,12,18
  // - Resto: por precio contra el umbral de 4.600.000.
  function getDavibankCuotas(priceInCOP) {
    if (data.davibankTypeMatch) {
      const enFase1 = dbFase1Num === null || todayNum() <= dbFase1Num;
      const cuotas  = enFase1 ? davibankPromoCuotas : davibankCuotasFase2;
      if (cuotas.length) return cuotas;
      // Lista de fase vacía: caer a la regla por precio en vez de dejar
      // el selector sin opciones.
    }
    return priceInCOP >= davibankUmbral ? cuotasDavibankAlto : cuotasDavibankBajo;
  }

  // ---- Codensa: ventana de campaña y cuotas ----
  // Misma semántica que DAVIbank: extremo vacío = sin límite en ese extremo,
  // fecha inválida = tarjeta oculta (fail-closed).
  const rawCdInicio = (data.codensaCampanaInicio || '').trim();
  const rawCdFin    = (data.codensaCampanaFin    || '').trim();
  const cdInicioNum = isoToNum(rawCdInicio);
  const cdFinNum    = isoToNum(rawCdFin);

  const cdErrores = [];
  if (rawCdInicio && cdInicioNum === null) cdErrores.push(`codensa_campana_inicio="${rawCdInicio}"`);
  if (rawCdFin    && cdFinNum    === null) cdErrores.push(`codensa_campana_fin="${rawCdFin}"`);
  const cdDatesValid = cdErrores.length === 0;
  if (!cdDatesValid) {
    console.error(
      '[financiamiento] Codensa OCULTO (fail-closed): fecha(s) de campaña ' +
      'inválida(s) en Theme Settings. Formato requerido YYYY-MM-DD. Revisar: ' +
      cdErrores.join(', ')
    );
  }

  function codensaWindowOpen() {
    if (!cdDatesValid) return false;
    const t = todayNum();
    if (cdInicioNum !== null && t < cdInicioNum) return false;
    if (cdFinNum    !== null && t > cdFinNum)    return false;
    return true;
  }

  // Codensa no tiene fases ni lista de skus: solo el umbral de precio.
  function getCodensaCuotas(priceInCOP) {
    return priceInCOP >= codensaUmbral ? cuotasCodensaAlto : cuotasCodensaBajo;
  }

  // ---- Nubank: ventana de campaña y cuotas ----
  // Misma semántica que Codensa: extremo vacío = sin límite en ese extremo,
  // fecha inválida = tarjeta oculta (fail-closed).
  const rawNuInicio = (data.nubankCampanaInicio || '').trim();
  const rawNuFin    = (data.nubankCampanaFin    || '').trim();
  const nuInicioNum = isoToNum(rawNuInicio);
  const nuFinNum    = isoToNum(rawNuFin);

  const nuErrores = [];
  if (rawNuInicio && nuInicioNum === null) nuErrores.push(`nubank_campana_inicio="${rawNuInicio}"`);
  if (rawNuFin    && nuFinNum    === null) nuErrores.push(`nubank_campana_fin="${rawNuFin}"`);
  const nuDatesValid = nuErrores.length === 0;
  if (!nuDatesValid) {
    console.error(
      '[financiamiento] Nubank OCULTO (fail-closed): fecha(s) de campaña ' +
      'inválida(s) en Theme Settings. Formato requerido YYYY-MM-DD. Revisar: ' +
      nuErrores.join(', ')
    );
  }

  function nubankWindowOpen() {
    if (!nuDatesValid) return false;
    const t = todayNum();
    if (nuInicioNum !== null && t < nuInicioNum) return false;
    if (nuFinNum    !== null && t > nuFinNum)    return false;
    return true;
  }

  function getNubankCuotas(priceInCOP) {
    return priceInCOP >= nubankUmbral ? cuotasNubankAlto : cuotasNubankBajo;
  }

  // Producto de la exclusión global: en el DOM solo están las tarjetas que
  // la cubren (Bancolombia y Bogotá según su lista, y Nubank). Si todas se
  // ocultan (ventana cerrada o precio bajo el mínimo), no queda banco con
  // qué calcular y se oculta la sección entera; si vuelve alguna, reaparece.
  // Fuera de la exclusión no hace nada: ahí la sección nunca se ha ocultado
  // por tarjetas, y no es este cambio el que lo va a empezar a hacer.
  function syncExclusionGlobal() {
    if (!data.exclusionGlobal) return;
    const section = document.querySelector('.financiamiento-section');
    if (!section) return;
    const visible = Array.from(document.querySelectorAll('.bank-card[data-bank]'))
      .some(card => card.style.display !== 'none');
    section.style.display = visible ? '' : 'none';
  }

  // ---- Sin financiación en ningún banco (v7) ----
  const rawSinFinDesde = (data.sinFinanciacionDesde || '').trim();
  const sinFinDesdeNum = isoToNum(rawSinFinDesde);
  if (data.sinFinanciacion && sinFinDesdeNum === null) {
    console.error(
      '[financiamiento] Calculadora OCULTA (fail-closed): ' +
      `sin_financiacion_desde="${rawSinFinDesde}" vacía o inválida en Theme Settings. ` +
      'Formato requerido YYYY-MM-DD.'
    );
  }

  function sinFinanciacionVigente() {
    if (!data.sinFinanciacion) return false;
    if (sinFinDesdeNum === null) return true;
    return todayNum() >= sinFinDesdeNum;
  }

  function applySinFinanciacion() {
    if (!sinFinanciacionVigente()) return;
    const section = document.querySelector('.financiamiento-section');
    if (section) section.style.display = 'none';
  }

  // ---- Cuotas por banco y tipo de producto (bancos existentes, SIN CAMBIOS) ----
  function getDaviviendaCuotas(priceInCOP) {
    return priceInCOP >= daviviendaUmbral ? cuotasDaviviendaAlto : cuotasDaviviendaBajo;
  }

  const cuotasBogota = productTypeLower.includes('iphone') ? cuotasBogotaIphone
                     : productTypeLower.includes('mac')    ? cuotasBogotaMac
                     : cuotasGenerales;

  // BBVA tiene lista propia tambien para el resto del catalogo (iPad, Watch,
  // audio, accesorios). Si el setting esta vacio se cae en las cuotas
  // generales, que es el comportamiento historico. El minimo de 800.000 lo
  // sigue aplicando updateBankVisibility con precioMinimoOtros: por debajo de
  // ese precio la tarjeta de BBVA no se muestra y esta lista no se usa.
  const cuotasBbva   = productTypeLower.includes('iphone') ? cuotasBbvaIphone
                     : productTypeLower.includes('mac')    ? cuotasBbvaMac
                     : cuotasBbvaOtros.length              ? cuotasBbvaOtros
                     : cuotasGenerales;

  const cuotasAvVillas = productTypeLower.includes('iphone') ? cuotasAvVillasIphone
                       : productTypeLower.includes('mac')    ? cuotasAvVillasMac
                       : cuotasGenerales;

  // ---- Helpers ----
  function formatMoney(amount) {
    return '$ ' + Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function getCurrentPrice() {
    // SCOPE: leer el precio SOLO dentro del contenedor del producto principal
    // (product-info.product__info-container). De lo contrario querySelector
    // devuelve el PRIMER .price-item--regular del documento, y al agregar el
    // carrusel de recomendaciones la pagina pasa a tener decenas de
    // .price-item--regular (uno por producto recomendado, por panel de variante).
    // Slick los clona/reordena, asi que el "primer" match podia ser el precio de
    // un accesorio barato del carrusel (por debajo del umbral) o un nodo a medio
    // renderizar -> getCurrentPrice() devolvia un valor erroneo y
    // updateBankVisibility ocultaba todos los bancos. Acotar al PDP lo evita.
    const scope = document.querySelector('product-info.product__info-container') || document;

    const selectors = [
      '.price__regular .price-item--regular',
      '.price-item--regular',
      '.actual_price_bold',
      '[data-product-price]',
      '.price__sale .price-item--sale',
      '.price__container .price',
    ];
    for (const sel of selectors) {
      const el = scope.querySelector(sel);
      if (el) {
        const raw = (el.textContent || el.getAttribute('data-product-price') || '0').trim();
        const price = parseFloat(raw.replace('$', '').replace(/\s/g, '').replace(/\./g, '').replace(',', '.'));
        if (!isNaN(price) && price > 0) return price;
      }
    }
    const variantSelect = scope.querySelector('[data-product-id]') || document.querySelector('[data-product-id]');
    if (variantSelect) {
      const jsonEl = document.getElementById('ProductJson-' + variantSelect.dataset.productId);
      if (jsonEl) {
        try {
          const variants = JSON.parse(jsonEl.textContent).variants;
          const variant  = variants.find(v => v.id.toString() === variantSelect.value.toString());
          if (variant?.price) return parseFloat(variant.price);
        } catch (_) {}
      }
    }
    return 0;
  }

  // ---- Banks configuration ----
  const banksConfig = {
    bancolombia: cuotasGenerales,
    davivienda:  getDaviviendaCuotas(getCurrentPrice()),
    bogota:      cuotasBogota,
    bbva:        cuotasBbva,
    av_villas:   cuotasAvVillas,
    davibank:    getDavibankCuotas(getCurrentPrice()),
    codensa:     getCodensaCuotas(getCurrentPrice()),
    nubank:      getNubankCuotas(getCurrentPrice()),
  };

  // Promo legacy sobre la configuración base (bancos existentes).
  applyPromo(banksConfig, getCurrentPrice());

  window._financiamientoState = {
    selectedBank: null,
    banksConfig,
    bankNames,
    // Superficie de depuración para QA.
    promoDebug: {
      legacy: {
        enabled:    !!data.promoEnabled,
        typeMatch:  !!data.promoTypeMatch,
        datesValid: promoDatesValid,
        dateErrors: promoFechasInvalidas,
        bancos:     promoBancos,
        cuotas:     promoCuotas,
        get windowOpen() { return promoWindowOpen(); },
        get applies()    { return promoApplies(getCurrentPrice()); },
      },
      davibank: {
        typeMatch:  !!data.davibankTypeMatch,
        excluido:   !!data.davibankExcluido,
        datesValid: dbDatesValid,
        dateErrors: dbErrores,
        inicio:     dbInicioNum,
        fase1Fin:   dbFase1Num,
        fin:        dbFinNum,
        cuotasFase1: davibankPromoCuotas,
        cuotasFase2: davibankCuotasFase2,
        get windowOpen() { return davibankWindowOpen(); },
        get cuotasHoy()  { return getDavibankCuotas(getCurrentPrice()); },
      },
      codensa: {
        excluido:   !!data.codensaExcluido,
        marcaOk:    data.codensaMarcaOk !== false,
        vendor:     data.productVendor || '',
        datesValid: cdDatesValid,
        dateErrors: cdErrores,
        inicio:     cdInicioNum,
        fin:        cdFinNum,
        cuotasAlto: cuotasCodensaAlto,
        cuotasBajo: cuotasCodensaBajo,
        get windowOpen() { return codensaWindowOpen(); },
        get cuotasHoy()  { return getCodensaCuotas(getCurrentPrice()); },
      },
      nubank: {
        excluido:   !!data.nubankExcluido,
        exclusionGlobal: !!data.exclusionGlobal,
        datesValid: nuDatesValid,
        dateErrors: nuErrores,
        inicio:     nuInicioNum,
        fin:        nuFinNum,
        cuotasAlto: cuotasNubankAlto,
        cuotasBajo: cuotasNubankBajo,
        get windowOpen() { return nubankWindowOpen(); },
        get cuotasHoy()  { return getNubankCuotas(getCurrentPrice()); },
      },
      get today() { return todayNum(); },
    },
  };

  let lastPrice  = '';
  let lastMonths = '';

  // ---- Selector population ----
  window.populateSelector = function populateSelector(cuotas) {
    selector.innerHTML = '';
    const max = Math.max(...cuotas);
    cuotas.forEach(months => {
      const opt = document.createElement('option');
      opt.value = months;
      opt.textContent = `${months} meses`;
      if (months === max) opt.selected = true;
      selector.appendChild(opt);
    });
    updateInstallmentAmount(true);
  };

  // ---- Calculation ----
  function updateInstallmentAmount(force = false) {
    const price  = getCurrentPrice();
    const months = parseInt(selector.value) || 1;
    if (force || price !== lastPrice || months !== lastMonths) {
      resultElement.textContent = formatMoney(price / months);
      lastPrice  = price;
      lastMonths = months;
    }
  }

  // ---- Visibilidad de bancos según precio ----
  // Davivienda:      visible si precio >= daviviendaPrecioMinimo (600 000) — SIN CAMBIOS
  // DAVIbank:        visible si precio >= davibankPrecioMinimo (800 000) Y campaña en ventana
  // Codensa:         visible si precio >= codensaPrecioMinimo (800 000) Y campaña en ventana
  // Nubank:          visible si precio >= nubankPrecioMinimo (600 000) Y campaña en ventana
  // Todos los demás: visible si precio >= precioMinimoOtros (800 000)
  // Si el banco seleccionado se oculta, se cambia al primer banco visible.
  function updateBankVisibility(priceInCOP) {
    // GUARD: nunca ocultar bancos con un precio invalido (0 / NaN / negativo).
    // getCurrentPrice() puede devolver 0 durante estados transitorios del DOM
    // (p.ej. cuando el carrusel de recomendaciones re-inicializa slick y dispara
    // el MutationObserver de abajo antes de que el bloque de precio se re-renderice).
    // Si reaccionamos a ese 0, ocultamos TODOS los bancos por error. Abortar y
    // conservar el estado visible actual es lo correcto.
    // Las ventanas de campaña de DAVIbank, Codensa y Nubank NO dependen del precio:
    // se aplican aparte en applyCampaignGates(), que sí corre siempre.
    if (!priceInCOP || isNaN(priceInCOP) || priceInCOP <= 0) return;

    const bankThresholds = {
      bancolombia: precioMinimoOtros,
      davivienda:  daviviendaPrecioMinimo,
      bogota:      precioMinimoOtros,
      bbva:        precioMinimoOtros,
      av_villas:   precioMinimoOtros,
      davibank:    davibankPrecioMinimo,
      codensa:     codensaPrecioMinimo,
      nubank:      nubankPrecioMinimo,
    };

    let needsNewSelection = false;

    Object.entries(bankThresholds).forEach(([bank, threshold]) => {
      const card = document.querySelector(`.bank-card[data-bank="${bank}"]`);
      if (!card) return; // banco desactivado o excluido en Liquid, no está en el DOM

      let shouldShow = priceInCOP >= threshold;
      if (bank === 'davibank') shouldShow = shouldShow && davibankWindowOpen();
      if (bank === 'codensa')  shouldShow = shouldShow && codensaWindowOpen();
      if (bank === 'nubank')   shouldShow = shouldShow && nubankWindowOpen();
      card.style.display = shouldShow ? '' : 'none';

      if (!shouldShow && window._financiamientoState?.selectedBank === bank) {
        needsNewSelection = true;
      }
    });

    if (needsNewSelection) {
      const firstVisible = document.querySelector('.bank-card[data-bank]:not([style*="display: none"])');
      if (firstVisible) selectBank(firstVisible.dataset.bank);
    }

    // Mostrar el label "Calcula tu cuota con tu banco:" solo si hay 2+ bancos visibles
    const visibleBanks = document.querySelectorAll('.bank-card[data-bank]:not([style*="display: none"])').length;
    const labelBancos  = document.querySelector('.financiamiento-label-bancos');
    if (labelBancos) labelBancos.style.display = visibleBanks >= 2 ? '' : 'none';

    syncExclusionGlobal();
  }

  // Gate de campaña independiente del precio: si la ventana está cerrada (o
  // sus fechas son inválidas), la tarjeta se oculta aunque getCurrentPrice()
  // todavía no haya leído un precio válido. Sin esto, un DOM lento en la carga
  // inicial dejaría al banco visible fuera de campaña. La visibilidad POSITIVA
  // la sigue decidiendo updateBankVisibility (precio).
  function applyWindowGate(bankKey, isOpen) {
    if (isOpen) return;
    const card = document.querySelector(`.bank-card[data-bank="${bankKey}"]`);
    if (!card) return;
    card.style.display = 'none';
    if (window._financiamientoState?.selectedBank === bankKey) {
      const firstVisible = document.querySelector('.bank-card[data-bank]:not([style*="display: none"])');
      if (firstVisible) selectBank(firstVisible.dataset.bank);
    }
  }

  // Los tres bancos con ventana de campaña, en un solo punto de llamada.
  // applySinFinanciacion va último: syncExclusionGlobal puede volver a
  // mostrar la sección y la fecha de corte tiene que ganarle.
  function applyCampaignGates() {
    applyWindowGate('davibank', davibankWindowOpen());
    applyWindowGate('codensa',  codensaWindowOpen());
    applyWindowGate('nubank',   nubankWindowOpen());
    syncExclusionGlobal();
    applySinFinanciacion();
  }

  // ---- Banco default: mayor número de cuotas entre los bancos visibles ----
  // DAVIbank, Codensa y Nubank van al final del orden: en empates de máximo,
  // los bancos existentes conservan la preferencia que ya tenían.
  const bankOrder = ['bancolombia', 'davivienda', 'bogota', 'bbva', 'av_villas', 'davibank', 'codensa', 'nubank'];

  function selectDefaultBank() {
    let defaultBank    = null;
    let defaultBankMax = 0;
    bankOrder.forEach(bank => {
      const card = document.querySelector(`.bank-card[data-bank="${bank}"]`);
      if (!card || card.style.display === 'none') return;
      const bankMax = Math.max(...(banksConfig[bank] || [0]));
      if (bankMax > defaultBankMax) {
        defaultBankMax = bankMax;
        defaultBank    = bank;
      }
    });
    if (!defaultBank) {
      // Fallback: primer banco visible en el DOM
      const first = document.querySelector('.bank-card[data-bank]:not([style*="display: none"])');
      if (first) defaultBank = first.dataset.bank;
    }
    if (defaultBank) selectBank(defaultBank);
  }

  // ---- Reconstrucción completa (precio nuevo o cambio de día) ----
  // Un solo camino para el MutationObserver, el cruce de medianoche y el
  // bfcache: reconstruye TODOS los bancos, re-aplica la promo legacy,
  // re-evalúa la fase y la ventana de DAVIbank y repuebla el selector si la
  // lista del banco seleccionado cambió.
  function refreshForPrice(price) {
    if (!price || isNaN(price) || price <= 0) return;

    const state    = window._financiamientoState;
    const prevBank = state?.selectedBank;
    const prevList = prevBank ? (banksConfig[prevBank] || []).join(',') : '';

    // Reconstruir TODOS los bancos. Necesario porque los umbrales de
    // Davivienda, DAVIbank, Codensa y Nubank y el mínimo de la promo legacy pueden
    // cruzarse al cambiar de variante (p.ej. 256 GB -> 512 GB), y porque la
    // fase de DAVIbank cambia el 31/8.
    banksConfig.bancolombia = cuotasGenerales;
    banksConfig.davivienda  = getDaviviendaCuotas(price);
    banksConfig.bogota      = cuotasBogota;
    banksConfig.bbva        = cuotasBbva;
    banksConfig.av_villas   = cuotasAvVillas;
    banksConfig.davibank    = getDavibankCuotas(price);
    banksConfig.codensa     = getCodensaCuotas(price);
    banksConfig.nubank      = getNubankCuotas(price);
    applyPromo(banksConfig, price);

    // Actualizar visibilidad de todos los bancos según nuevos umbrales.
    // OJO: puede RESELECCIONAR banco (via selectBank) si el actual se ocultó,
    // y selectBank ya repobló el selector con la config recién reconstruida.
    updateBankVisibility(price);
    applyCampaignGates();

    // Re-leer el banco DESPUÉS de la visibilidad: usar la captura previa
    // repoblaría el selector con las cuotas de un banco ya deseleccionado.
    const currentBank = state?.selectedBank;

    if (currentBank && currentBank !== prevBank) {
      // Reselección ya manejada dentro de updateBankVisibility -> selectBank.
    } else if (currentBank && (banksConfig[currentBank] || []).join(',') !== prevList) {
      populateSelector(banksConfig[currentBank]);
    } else {
      updateInstallmentAmount(true);
    }
  }

  // ---- Inicialización ----
  applyCampaignGates();
  updateBankVisibility(getCurrentPrice());
  selectDefaultBank();

  selector.addEventListener('change', e => { e.stopPropagation(); updateInstallmentAmount(true); });
  selector.addEventListener('input',  e => { e.stopPropagation(); updateInstallmentAmount(true); });

  // ---- Watch for variant/price changes ----
  const observer = new MutationObserver(() => {
    const price = getCurrentPrice();

    // GUARD: ignorar disparos transitorios donde el precio aun no es valido.
    // El observer es amplio (subtree:true) y se dispara con cualquier mutacion
    // dentro de product-info, incluidas las que provoca slick del carrusel de
    // recomendaciones al clonar/medir nodos. Si leemos 0/NaN aqui, no hacemos
    // nada: esperamos al siguiente disparo con un precio real.
    if (!price || isNaN(price) || price <= 0) return;

    if (price !== lastPrice) refreshForPrice(price);
  });
  observer.observe(productInfoSection, { attributes: true, childList: true, subtree: true });

  // ---- Cruce de medianoche en pestañas abiertas ----
  // Los cortes de campaña (DAVIbank: 31 ago fin de 24 meses, 31 oct fin del
  // beneficio; Codensa: 25 sep inicio, 31 oct fin; Nubank: 5 oct inicio,
  // 31 dic fin; sin financiación: MacBook Neo desde el 1 nov) deben aplicar
  // también en una pestaña que quedó abierta.
  // Chequeo barato cada 60 s: solo hace trabajo si cambió el día.
  let diaActual = todayNum();
  setInterval(() => {
    const t = todayNum();
    if (t === diaActual) return;
    diaActual = t;
    applyCampaignGates();
    refreshForPrice(getCurrentPrice());
  }, 60000);

  // ---- bfcache (Safari) ----
  // Al restaurar desde back/forward cache el JS no se re-ejecuta: la página
  // vuelve con el estado del momento en que se abandonó, que puede ser de
  // otro día (misma clase de bug que el "dead drawer" del carrito).
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    diaActual = todayNum();
    applyCampaignGates();
    refreshForPrice(getCurrentPrice());
  });
});

// ========== GLOBAL EXPORTS ==========
window.toggleFinanciamiento = toggleFinanciamiento;
window.togglePlan0es3       = togglePlan0es3;
window.selectBank           = selectBank;
